import { Cleaning } from '../../models/Cleaning/Cleaning';
import { Action } from 'redux';
import {
    CLEANING_UPDATE_ADDRESS,
    CLEANING_UPDATE_DATETIME,
    CLEANING_UPDATE_REQUEST,
    CLEANING_UPDATE_SEARCH_ADDRESSES
} from '../../actions/Cleaning/cleaning';
import { Location } from '../../models/Delivery/Delivery';

export interface CleaningState {
    cleaning: Cleaning;
    pickedDate: string;
    pickedAddress: string;
    loading: boolean;
    searchResults: Location[];
}

const initialState: CleaningState = {
    cleaning: {
        date: '',
        address: '',
        rooms: 1,
        windows: false,
        windowsQuantity: 1
    },
    pickedDate: '',
    pickedAddress: '',
    loading: false,
    searchResults: []
};

export const cleaningState = (state: CleaningState = initialState, action: Action) => {
    switch (action.type) {
        case CLEANING_UPDATE_REQUEST: {
            return {
                ...state,
                cleaning: (action as any).cleaning
            };
        }
        case CLEANING_UPDATE_DATETIME: {
            return {
                ...state,
                cleaning: {
                    ...state.cleaning,
                    date: (action as any).pickedDate
                },
                pickedDate: (action as any).pickedDate
            };
        }
        case CLEANING_UPDATE_SEARCH_ADDRESSES: {
            return {
                ...state,
                searchResults: (action as any).searchResults
            };
        }
        case CLEANING_UPDATE_ADDRESS: {
            const location = (action as any).pickedAddress as Location;
            return {
                ...state,
                pickedAddress: location,
                cleaning: {
                    ...state.cleaning,
                    address: location.address
                }
            };
        }
        default: return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Cleaning/cleaning.ts